import {useEffect, useState} from "react";
import Center from "../components/utils/Center";
import {Avatar, Button, ListItemAvatar, Stack, TextField, Typography} from "@mui/material";
import axios from 'axios';
import Logout from "../components/auth/Logout";
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Checkbox from '@mui/material/Checkbox';
import IconButton from '@mui/material/IconButton';
import LinkIcon from '@mui/icons-material/Link';
import {useNavigate} from "react-router-dom";

interface Props {
}

const Search = ({}: Props) => {
  let navigate = useNavigate();

  const [channelId, setChannelId] = useState<string[]>([]);
  const [itemData, setItemData] = useState<any[]>([]);

  const [checked, setChecked] = useState<string[]>([]);

  const [countryFilter, setCountryFilter] = useState('');
  const [maxSubscriberFilter, setMaxSubscriberFilter] = useState(-1);
  const [minSubscriberFilter, setMinSubscriberFilter] = useState(-1);

  const handleToggle = (value: string) => () => {
    const currentIndex = checked.indexOf(value);
    const newChecked = [...checked];

    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }

    setChecked(newChecked);
  };

  useEffect(() => {
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  function getChannel() {
    const itemData: any[] = [];
    axios.get(`https://us-central1-influencer-database-c0208.cloudfunctions.net/api/getChannel?channelId=${channelId}`)
      .then((response) => {
        console.log(response.data);
        itemData.push({
          img: response.data.mediumThumbnail,
          title: response.data.title,
          subscriberCount: response.data.subscriberCount.toLocaleString(),
          channelLink: response.data.url,
          channelId: response.data.id,
          uploadsId: response.data.uploadsId,
          rows: 2,
          cols: 2,
          featured: true,
        })
        setItemData(itemData);
      })
      .catch((error) => {
        console.log(error);
      });
  }

  function onBackClicked() {
    navigate('/');
  }

  function downloadBlob(content: any, filename: string, contentType: string) {
    // Create a blob
    var blob = new Blob([content], { type: contentType });
    var url = URL.createObjectURL(blob);

    // Create a link to download it
    var pom = document.createElement('a');
    pom.href = url;
    pom.setAttribute('download', filename);
    pom.click();
  }

  function getAllChannels() {
    const itemData: any[] = [];
    const params = {
      params: {
        country: countryFilter,
        maxSubscriberCount: maxSubscriberFilter,
        minSubscriberCount: minSubscriberFilter,
      },
    };

    axios.get('https://us-central1-influencer-database-c0208.cloudfunctions.net/api/getChannels', params)
      .then((response) => {

        const channels: any[] = response.data.jsonData;
        channels.forEach(value => {
          itemData.push({
            img: value.mediumThumbnail,
            title: value.title,
            subscriberCount: value.subscriberCount.toLocaleString(),
            channelLink: value.url,
            channelId: value.id,
            uploadsId: value.uploadsId,
            rows: 2,
            cols: 2,
            featured: true,
          })
        });
        setItemData(itemData);
      })
      .catch((error) => {
        console.log(error);
      });
  }

  function downloadChannelsCsv() {
    const d = new Date();
    const n = d.toLocaleTimeString().replaceAll(':', '_')
      .replaceAll(' PM', '').replaceAll(' AM', '');
    const params = {
      params: {
        country: countryFilter,
        maxSubscriberCount: maxSubscriberFilter,
        minSubscriberCount: minSubscriberFilter,
      }
    };
    axios.get('https://us-central1-influencer-database-c0208.cloudfunctions.net/api/getChannels', params)
      .then((response) => {
        const channelsCSV: any = response.data.csvData;
        downloadBlob(channelsCSV, `export-${n}.csv`, 'text/csv;charset=utf-8;')
      })
      .catch((error) => {
        console.log(error);
      });
  }

  const handleGetChannelIdChange = (event: any) => {
    const {
      target: {value},
    } = event;
    setChannelId(value);
  }

  const handleCountryChange = (event: any) => {
    const {
      target: {value},
    } = event;
    setCountryFilter(value);
  }

  const handleMaxSubscriberChange = (event: any) => {
    const {
      target: {value},
    } = event;
    setMaxSubscriberFilter(value);
  }

  const handleMinSubscriberChange = (event: any) => {
    const {
      target: {value},
    } = event;
    setMinSubscriberFilter(value);
  }

  function onGetVideosClicked() {
    itemData.forEach(value => {
      axios.get(`https://us-central1-influencer-database-c0208.cloudfunctions.net/api/addChannelVideos?channelId=${value.channelId}&playlistId=${value.uploadsId}`)
        .then((response) => {
          console.log('Channel videos added : ' + channelId);
        })
        .catch((error) => {
          console.log(error);
        });
    });
  }

  function updateFactsForChannels() {
    itemData.forEach(value => {
      let channelId = value.channelId;
      axios.get(`https://us-central1-influencer-database-c0208.cloudfunctions.net/api/getChannelFacts?channelId=${channelId}`).then(
        () => {
          console.log('Added facts for channels');
        }
      ).catch((error) => {
        console.log(error);
      })
    });
  }

  function downloadFactsForChannels() {
    const d = new Date();
    const n = d.toLocaleTimeString().replaceAll(':', '_')
      .replaceAll(' PM', '').replaceAll(' AM', '');
    axios.get('https://us-central1-influencer-database-c0208.cloudfunctions.net/api/downloadFacts').then( (response) => {
      const channelsCSV: any = response.data.csvData;
      downloadBlob(channelsCSV, `export-${n}.csv`, 'text/csv;charset=utf-8;')
      }
    )
  }

  return (
    <Center>
      <Stack width={360} spacing={2} direction="column">
        <Stack spacing={2} direction="row">
          <TextField multiline id="getChannel" label="Channel ID" variant="outlined"
                     onChange={handleGetChannelIdChange}/>
          <Button variant="contained" onClick={getChannel}>
            Get
          </Button>
          <Logout/>
        </Stack>
        <Stack spacing={2} direction="row">
          <TextField multiline id="country" label="Country" variant="outlined" onChange={handleCountryChange}/>
          <TextField multiline id="maxSubscriber" label="Max Subscriber" variant="outlined"
                     onChange={handleMaxSubscriberChange}/>
          <TextField multiline id="minSubscriber" label="Min Subscriber" variant="outlined"
                     onChange={handleMinSubscriberChange}/>
        </Stack>
        <Stack spacing={2} direction="row">
          <Button variant="contained"
                  onClick={getAllChannels}>
            Search
          </Button>
          <Button variant="contained"
                  onClick={onBackClicked}>
            Back
          </Button>
        </Stack>
        <Stack spacing={2} direction="row">
          <Button variant="contained" onClick={downloadChannelsCsv}>
            Channel Data CSV
          </Button>
          <Button variant="contained"
                  onClick={onGetVideosClicked}>
            Update Videos
          </Button>
        </Stack>
        <Stack spacing={2} direction="row">
          <Button variant="contained" onClick={updateFactsForChannels}>
            Generate facts
          </Button>
          <Button variant="contained" onClick={downloadFactsForChannels}>
            Download facts
          </Button>
        </Stack>
        <Stack spacing={2} direction="row">
          <List sx={{width: '100%', height: '100%', maxHeight: 500, maxWidth: 600, bgcolor: 'background.paper'}}>
            {itemData.map((value) => {
              const labelId = `checkbox-list-label-${value.title}`;
              return (
                <ListItem
                  key={value.title}
                  secondaryAction={
                    <IconButton edge="end" aria-label="comments" onClick={() => window.open(`${value.channelLink}`)}>
                      <LinkIcon/>
                    </IconButton>
                  }
                  disablePadding>
                  <ListItemButton role={undefined} onClick={handleToggle(value.uploadsId)} dense>
                    <ListItemIcon>
                      <Checkbox
                        edge="start"
                        checked={checked.indexOf(value.uploadsId) !== -1}
                        tabIndex={-1}
                        disableRipple
                        inputProps={{'aria-labelledby': labelId}}
                      />
                    </ListItemIcon>

                    <ListItemAvatar>
                      <Avatar alt={value.title} src={value.img}/>
                    </ListItemAvatar>

                    <ListItemText id={labelId} primary={`${value.title}`}
                                  secondary={
                                    <>
                                      <Typography
                                        sx={{display: 'inline'}}
                                        component="span"
                                        variant="body2"
                                        color="text.primary">
                                      </Typography>
                                      {`Subscribers: ${value.subscriberCount}`}
                                    </>
                                  }/>
                  </ListItemButton>
                </ListItem>
              );
            })}
          </List>
        </Stack>
      </Stack>
    </Center>
  );
};

export default Search;
